import { Navigate } from "react-router-dom";

export default function AdminRoute({ isLoggedIn, children }) {
    if (!isLoggedIn) {
        return <Navigate to="/Login" replace />;
    }
    return children;
}
